<template>
  <div class="signin">
    <div class="admin">
      <img src="../assets/组 5337.png" alt="" />
      <!-- <span class="title">admin</span>
      <span class="explain">云南航天工程物探检测股份有限公司</span> -->

      <div>
        <div class="title">{{user.displayName}}</div>
        <div class="explain">{{user.department}}</div>
      </div>
    </div>
    <div class="pictrue">
      <a href="https://aeroiot.cn/mall_tuxiangweiyi">
        <img src="../assets/蒙版组 6.jpg" />
      </a>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
// import store from '../store';

export default {
  name: "SignIn",
  data() {
    return {
      user: {}
    };
  },
  mounted:function(){
    this.loadUserInfo();
  },
  methods:{
    loadUserInfo:function(){
      var userInfoApi = this.$apis.userinfo;
      this.$axios.get(userInfoApi).then(
          response => {
              if (response.status === 200 && response.data) {    
                  var result = response.data;
                  if(result.code === 200){
                    this.user = result.data;    
                  }else{
                    console.log('用户查询失败:' + result.message);
                  }                                  
              }
              else{
                  console.log('用户查询失败:' + response.message);
              } 
          },
          error => {
            console.log('用户详情接口调用失败:' + error.message);
          }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signin{
  position: relative;
  width: 445px;
  margin-top: 63px;
}
.signin .admin {
  width: 445px;
  height: 127px;
  background-color: white;
  display: flex;
  flex-direction: row;
}
.signin .admin img {
  padding: 22px 16px 0 28px;
  width: 68px;
  height: 68px;
}
.signin .admin .title {
  font-size: 18px;
  font-weight: bold;
  margin-top: 31px;
  color: black;
}
.signin .admin .explain {
  font-size: 12px;
  margin-top: 8px;
  color: black;
}
.signin .pictrue {
  margin-top: 20px;
}

@media (max-width: 1200px) {
  .signin{
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue